import client from '../../client'
import {
  Profile,
  UpdateProfileParams,
  EmailDeliveryOptions,
  EmailDeliveryResponse,
} from './types'
import { ApiResponse } from '../../types'
import { UserId } from '../users'
import snakecaseKeys from 'snakecase-keys'

export * from './types'

export const me = async () => {
  const { data }: ApiResponse<Profile> = await client.get('/user/profiles/me')
  return data
}

export const update = async (userId: UserId, params: UpdateProfileParams) => {
  return await client.put(
    `/user/profiles/${userId}`,
    snakecaseKeys(params as { [key: string]: any })
  )
}

export const getEmailDeliveryOptions = async () => {
  const { data }: ApiResponse<EmailDeliveryResponse> = await client.get(
    '/user/profiles/deliveryMail'
  )

  // 各値の 0 | 1 をbooleanに変換する
  return Object.keys(data).reduce(
    (acc, key) => ({
      ...acc,
      [key]: data[key as keyof EmailDeliveryResponse] === 1 ? true : false,
    }),
    {} as EmailDeliveryOptions
  )
}

export const updateEmailDeliveryOptions = async (
  options: EmailDeliveryOptions
) => {
  return await client.put(
    '/user/profiles/deliveryMail',
    // 各値のbooleanを 0 | 1 に変換する
    Object.keys(options).reduce(
      (acc, key) => ({
        ...acc,
        [key]: options[key as keyof EmailDeliveryOptions] ? 1 : 0,
      }),
      {}
    )
  )
}
